import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { BatteryTestsPage } from './pages/BatteryTestsPage';
import { BatteryModelsPage } from './pages/BatteryModelsPage';
import { LoginPage } from './pages/LoginPage';
import { useAuth } from './hooks/useAuth';

export function App() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/battery-tests" element={<BatteryTestsPage />} />
        <Route path="/battery-models" element={<BatteryModelsPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}
